module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "no-found",
    staticStyle: {
      "flex-direction": "column"
    },
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('img', {
    attrs: {
      "width": "300",
      "height": "310",
      "src": require("../../../assets/images/404.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-wrap m-t-20"
  }, [_vm._v("访问出错！")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c584627e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/normal/404.vue
// module id = 1987
// module chunks = 2